export default __webpack_public_path__ + "static/appnexus-d473f74d0e98f9a931c969215e0f19f6.svg";